// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__u-eii","title":"AfterBackImages_title__2lcT5","images":"AfterBackImages_images__2vCof"};